module.exports = __webpack_public_path__ + "img/diamante.b8d656d9.png";